var C                   = require("consts"),
    Class               = require('Class'),
    $                   = require("jquery"),
    Utils               = require('Utils'),
    BaseLayer           = require("./BaseLayer"),
    LayerCollection     = require("./LayerCollection"),
    Layer               = require("./Layer"),
    TileLayer           = require("./TileLayer"),
    VectorLayer         = require("./VectorLayer"),
    OmsVectorLayer      = require("./OmsVectorLayer"),
    OmsVectorFeatureLayer   = require("./OmsVectorFeatureLayer"),
    OmsMVTLayer         = require("./OmsMVTLayer"),
    OmsCategoryLayer    = require("./OmsCategoryLayer"),
    OmsChartsLayer      = require("./OmsChartsLayer"),
    WidgetManager       = require("./WidgetManager"),
    Measurement         = require("./Measurement"),
    PublicMapDraw       = require('./PublicMapDraw'),
    GenericGeometryEditor = require("./GenericGeometryEditor/index"),
    ol                  = require("openlayers"),
    MarkerLayer         = require("./MarkerLayer"),
    TileCounter         = require("./OmsExtTileCounter"),
    Lang                = require("./Lang");

var _ = require("underscore");
window._ = _;
window.ol = ol;

var layerTypes = [
    "tile",
    "vector",
    "oms_vector",
    "oms_vector_category",
    "oms_chart_layer",
    "oms_vector_feature",
    "oms_mvt"
];

var View = Class.extend({

    includes: [
        require('Events'),
        require('./Balloon')
    ],

    /**
     *
     */
    options: {
        show               : true,
        publication: {
            map_position: {
                zoom               : 2,
                min_zoom            : 1,
                max_zoom            : 30,
                // center             : [37.6155600, 55.7522200]
                center             : [4187344.9851, 7509246.96669]
            }
        },
        misc_data: {
            objects_counter_style: {}
        }
        // centerProj         : 'EPSG:4326'
    },

    /**
     *
     */
    _project: undefined,

    /**
     *
     */
    _map: undefined,


    /**
     *
     * @param element
     * @param project
     * @param options
     */
    initialize: function(element, project, options){
        var that = this,
            baseLayerCfg;

        if(!project || !element){
            throw new Error("Bad arguments set for view initialization");
        }

        that._element = $(element);
        that._element.css('opacity', '0');

        // TODO нигде не используется, проверить и удалить гада
        that._visiblePLayers = [];
        that._utfIgnoreClick = false;
        that._utfIgnoreClickTimer = 0;

        that._project = project;
        that._pLayerList = false;
        that._elements = {};

        that.isTouch      = Utils.isTouch();
        that.webglEnabled = Utils.webglEnabled();

        that._layers = new LayerCollection(that);
        that._layersForInteractions = {};
        that._markerLayers = new LayerCollection(that);

        that._widgetManager = new WidgetManager(that, [], {});

        that._http_prefix = (window.location.protocol != "https:") ? 'http:' : 'https:';

        that.Lang = new Lang({
            lng: that._project.lng,
            translations: options.translations || {}
        });

        that.setOptions(options);

        that._setupPublicationConfig();

        baseLayerCfg = $.extend({}, that.options.publication, {
            urlTemplate : that.getProject().options['tilesUrl'],
            mapboxStyleUrlTemplate: that.getProject().options['styleUrl'].replace('{map_code}', that.getProject().options['mapCode'])
        });

        that._createHtmlStruct($(element));

        that.getParams = that._parseLocationQuery();

        var pinchZoom = new ol.interaction.PinchZoom({
            constrainResolution: true
        });


        var publication = that.options.publication,
            mapPosition = publication.map_position;
        // Пользовательское начальное смещение карты
        if (publication.map_position_manual){
            mapPosition = $.extend(true, {}, mapPosition, publication.map_position_manual);
        }

        that._map = new ol.Map({
            target      : that._elements.mapContainer,
            layers      : [],
            view        : new ol.View({
                center: mapPosition.center,
                zoom: mapPosition.zoom,
                maxZoom: mapPosition.max_zoom,
                minZoom: mapPosition.min_zoom,
                zoomFactor: 2
            }),
            controls: [new ol.control.Attribution({
                collapsible: false
            })],

            interactions: (
                window.location.search.indexOf("nozoom") != -1)
                    ? ol.interaction.defaults({mouseWheelZoom:false})
                    : ol.interaction.defaults({altShiftDragRotate:false, pinchRotate:false, pinchZoom: false})
                        .extend([
                            new ol.interaction.OMJSMouseWheelZoom({duration: 190}),
                            pinchZoom
                        ])
        });

        if (!that.isTouch) {
            ol.events.listen(
                that.getMap().getTargetElement(),
                'contextmenu',
                function(event){
                    event = new ol.MapBrowserEvent(
                        'contextmenu',
                        that.getMap(),
                        event,
                        false,
                        that.getMap().frameState_
                    );
                    that.fire('finish_drawing', event);
                    event.preventDefault();
                }
            );
        }


        // interactions: ol.interaction.defaults({pinchZoom: false}).extend([
        //     new ol.interaction.PinchZoom({
        //         constrainResolution: true // force zooming to a integer zoom
        //     })
        // ]),

        if(!that.options.show){
            that.hide();
        }

        that._baseLayer = new BaseLayer(that, baseLayerCfg, that._elements['container']);

        that._measurement = new Measurement(that._map, that, {});

        that._publicMapDraw = new PublicMapDraw(that._map);

        that._genericGeometryEditor = new GenericGeometryEditor(that._map)

        that._setMapInteractions();

        that.getMap().addLayer(that._baseLayer.olLayer);
        that.getMap().addLayer(that._layers._olLayersGroup);
        that.getMap().addLayer(that._markerLayers._olLayersGroup);
        that._markerLayers.add(new MarkerLayer({
            'group': 'default'
        }));

        // Инициализируем счётчик тайлов для OMS Extention
        if($('html').attr("omsExt") == 'true'){
            new TileCounter(that);
        }
    },

    _setPadding: function(mapPosition) {
        var that = this;

        if (mapPosition.padding) {
            setTimeout(function () {
                var center = mapPosition.center;

                that.getMap().getView().fit(
                    center.concat(center),
                    {
                        maxZoom: mapPosition.zoom,
                        size: that.getMap().getSize(),
                        padding: mapPosition.padding
                    }
                );

                that._element.css('opacity', '1');
            }, 0);
        }
        else {
            that._element.css('opacity', '1');
        }
    },

    _setupPublicationConfig: function () {
        var that = this,
            i;
        if(!that.webglEnabled){
            for(i in that.options.publication['base_maps']){
                if(that.options.publication['base_maps'][i]['vector']){
                    that.options.publication['base_maps'][i]['vector'] = false;
                    // Ставим метку о том, что эта подложка должна была быть векторной.
                    that.options.publication['base_maps'][i]['should_be_vector'] = true;
                }
            }
        }

        return that;
    },

    _setMapInteractions: function(){
        var that = this;

        var selected = {
            layer  : false,
            feature: false
        };

        that._map.on(['click', 'dblclick', 'pointermove', 'singleclick'], function(evt){
            var hasFeatureAtPixel;

            try{
                hasFeatureAtPixel = that._map.hasFeatureAtPixel(evt.pixel, function(candidate){
                    var omjsLayer = candidate.get('omjsLayer');
                    return omjsLayer && omjsLayer.hasEventListeners(evt.type);
                    // return true;
                });
            }catch(e){
                hasFeatureAtPixel = false;
            }

            if (hasFeatureAtPixel) {
                var layerAndFeature = that._map.forEachFeatureAtPixel(
                    evt.pixel,
                    function(feature, layer){
                        if (layer) {
                            var omjsLayer = layer.get('omjsLayer');
                            if (omjsLayer && (
                                omjsLayer instanceof omjs.View.VectorLayer ||
                                omjsLayer instanceof omjs.View.ImageLayer ||
                                omjsLayer instanceof omjs.View.MVTLayer
                                )) {
                                return {
                                    layer: omjsLayer,
                                    feature: feature
                                };
                            }
                        }
                    }
                );

                if (layerAndFeature) {
                    if (evt.type == 'click' || evt.type == 'singleclick' || evt.type == 'dblclick') {
                        //на touch устройствах click проходит по всему пирогу и надо предотвратить срабатывание
                        // click по utfgrid, если клик был по векторному объекту
                        that._utfIgnoreClick = true;
                        clearTimeout(that._utfIgnoreClickTimer);
                        that._utfIgnoreClickTimer = setTimeout(function(){
                            that._utfIgnoreClick = false;
                        }, 100);
                    }

                    layerAndFeature['layer'].fire(evt.type, {
                        feature: layerAndFeature['feature'],
                        olEvent: evt
                    });

                    if(evt.type == 'pointermove' && omjs.ol.events.condition.mouseOnly(evt)){
                        if(selected['feature'] != layerAndFeature['feature']){
                            if(selected['feature']){
                                selected['layer'].fire('pointerleave', {
                                    feature: selected['feature'],
                                    olEvent: evt
                                });
                            }
                            selected = layerAndFeature;
                            selected['layer'].fire('pointerenter', {
                                feature: selected['feature'],
                                olEvent: evt
                            });
                        }
                    }
                }
            }else{
                if(evt.type == 'pointermove' && selected['feature']){
                    selected['layer'].fire('pointerleave', {
                        feature: selected['feature'],
                        olEvent: evt
                    });

                    selected['feature'] = selected['layer'] = false;
                }
            }
        })
    },

    /**
     *
     * @private
     */
    _createHtmlStruct: function(container){
        var that = this,
            classes;

        if(container.length !== 1){
            throw new Error('Bad element for view initialization');
        }

        that._elements['container'] = container[0];
        that._elements['mapContainer'] = document.createElement('div');
        that._elements['mapContainer'].className = 'omjs-map-container';
        that._elements['container'].appendChild(that._elements['mapContainer']);

        classes = Utils.splitWords(that._elements['container'].className);
        if(!~classes.indexOf('omjs-container')){
            classes.push('omjs-container');
            that._elements['container'].className = classes.join(" ");
        }
    },

    /**
     *
     */
    getContainer: function(){
        return $(this._elements['container']);
    },

    /**
     *
     */
    getMap: function(){
        return this._map;
    },

    /**
     *
     */
    getProject: function(){
        return this._project;
    },

    /**
     *
     */
    getLayers: function(){
        return this._layers;
    },

    /**
     *
     */
    getWidgetManager: function(){
        return this._widgetManager;
    },

    /**
     *
     */
    show: function(){
        var that = this;

        $(that._elements.container).removeClass('hidden');
        return that;
    },

    /**
     *
     */
    hide: function(){
        var that = this;

        $(that._elements.container).addClass('hidden');
        return that;
    },

    /**
     *
     * @param layerCode
     * @param options
     */
    addLayer: function(layerCode, options){
        var that      = this,
            loading   = $.Deferred(),
            pLayers,
            layerType = "tile",
            newLayer  = {},
            mapCode = that._project.options.mapCode;

        options = options || {};

        if('layerType' in options && ~layerTypes.indexOf(options['layerType'])){
            layerType = options['layerType'];
        }
        // Если это уже слой view просто добавляем его и валим отсюда
        // TODO возможно нужна более жесткая проверка - что мы пытаемся добавить
        if (layerCode instanceof Layer) {
            that.getLayers().add(layerCode);
            loading.resolve(newLayer);
            return loading;
        } else if (layerCode instanceof ol.layer.Base) {
            newLayer = new Layer({});
            newLayer.setMapLayer(layerCode);
            that.getLayers().add(newLayer);
            loading.resolve(newLayer);
            return loading;
        } else {
            if(layerType == C.TILE_LAYER){
                options.urlTemplate = that.getProject().options['tilesUrl'];
                options.mapCode = mapCode;
                newLayer = new TileLayer(options);
            } else if (layerType == C.VECTOR_LAYER) {
                options.returnGeom = '1';
                options.geomSR = '3857';
                newLayer = new VectorLayer(options);
            } else if (layerType == C.OMS_VECTOR_LAYER) {
                options.returnGeom = '1';
                options.geomCentroid = '1';
                options.geomSR = '3857';
                newLayer = new OmsVectorLayer(options);
            } else if (layerType == C.OMS_CATEGORY_LAYER) {
                options.returnGeom = '1';
                options.geomCentroid = '1';
                options.geomSR = '3857';
                newLayer = new OmsCategoryLayer(options);
            } else if (layerType == C.OMS_CHARTS_LAYER) {
                options.returnGeom = '1';
                options.geomCentroid = '1';
                options.geomSR = '3857';
                newLayer = new OmsChartsLayer(options);
            } else if(layerType == C.OMS_VECTOR_FEATURE_LAYER) {
                options.returnGeom = '1';
                options.geomSR = '3857';
                options.urlTemplate = that.getProject().options['apiUrl'];
                options.mapCode = mapCode;
                newLayer = new OmsVectorFeatureLayer(options);
            } else if(layerType == C.OMS_MVT_LAYER){
                options.urlTemplate = that.getProject().options['tilesUrl'];
                options.mapCode = mapCode;
                newLayer = new OmsMVTLayer(options);
            }
            that.getLayers().add(newLayer);

        }
        // TODO тут какое то ... 0_o. Нужно решить правильно ли это!!!
        // Загружаем список слоёв

        /* Denis:
         Для чего мы тут грузим список слоёв?
         Ведь достаточно загрузить только один слой не?
         Если это для гибридного тайлового слоя - нужно лучше подумать, как сделать лучше.
         */

        // if (!that._pLayerList) {
        //     loading = that.getProject().loadLayers();
        // } else {
        //     loading.resolve(that._pLayerList);
        // }

        // Настраиваем слой после загрузки списка слоёв.
        return that.getProject().getLayers().then(function(layerList){
            var codes = Utils.splitWords(layerCode);
            var defe = $.Deferred();
            if(!that._pLayerList){
                that._pLayerList = layerList;
            }

            pLayers = that._pLayerList.filter(function(l){
                return Boolean(~codes.indexOf(l.get('code')));
            });
            // Если слой векторный то нужно еще загрузить объекты

            if(layerType in C.VECTOR_LAYER_IDS){
                if (pLayers.at(0)) {
                    if (pLayers.at(0).get('render_type') == 1) {
                        that._mergeNecessaryFields(pLayers.at(0), options.fields).done(function(fields){
                            options.fields = fields;
                            if (layerType == 'oms_chart_layer' && !pLayers.at(0).get('selected')) {
                                newLayer.loadOptions = options;
                                defe.resolve(pLayers);
                            }
                            pLayers.at(0).loadObjects(options).then(function () {
                                defe.resolve(pLayers);
                            });
                        });
                    }
                }
            }else {
                defe.resolve(pLayers);
            }
            return defe;
        }).then(function(pLayer){
            return newLayer._setup({projectLayers: pLayer});
        }).fail(function(){
            that.removeLayer(newLayer);
        });
    },


    _mergeNecessaryFields: function(projectLayer, fields) {
        var res= [];
        var that = this;
        that.newArray = [];
        var def = $.Deferred();
        projectLayer.project.loadStructure(projectLayer.get('code')).then(function(arr) {
            if (projectLayer.get('vectorSettings') && projectLayer.get('vectorSettings').showPopup) {
                res.push(projectLayer.get('vectorSettings')['popupColumnCode']);
            }
            $.each(arr, function (id, elem) {
                if(projectLayer.get("visualSettings")) {
                    if(projectLayer.get("visualSettings").classesSettings.columns) {
                        $.each(projectLayer.get("visualSettings").classesSettings.columns, function (sort, column) {
                            if (elem.id == column.id) {
                                that.newArray[sort] = elem.code;
                                res.push(elem.code);
                                if (projectLayer.get('style_mode') == 3) {
                                    res.push(projectLayer.get('visualSettings')['columnCode']);

                                    if (~[4, 5, 6].indexOf(projectLayer.get("visualSettings").type)) {
                                        if (projectLayer.get("visualSettings").classesSettings.sizeType == 3) {
                                            res.push(elem.sizeColumnCode);
                                        }
                                    }

                                    //для загрузки колонки с текстом
                                    if (projectLayer.get("visualSettings").showText) {
                                        res.push(elem.code);
                                    }
                                }
                            }
                        });
                    }
                    if (projectLayer.get("visualSettings").showText) {
                        res.push(elem.code);
                    }
                    if(projectLayer.get("visualSettings").classesSettings.classes) {
                        var column = projectLayer.get("visualSettings").column;
                        if (column == elem.id) {
                            res.push(elem.code);
                        }
                    }
                }
            });
            if (projectLayer.get("render_type") != 1) {
                return res;
            }

            if (projectLayer.get('vectorSettings').showPopup) {
                res.push(projectLayer.get('vectorSettings')['popupColumnCode']);
            }

            if (fields) {
                if (typeof fields == 'string') {
                    fields = [fields];
                }
            } else {
                fields = [];
            }

            fields = fields.concat(res);
            fields = _.uniq(fields);
            def.resolve(fields);
            return fields;
        });
        return def;
    },

    /**
     *
     */
    removeLayer: function(layer){
        var that = this;

        that.getLayers().remove(layer);
        return that;
    },

    /**
     *
     */
    getBaseLayer: function(){
        return this._baseLayer;
    },

    /**
     *
     */
    _getBaseInfoById: function(id){
        var that = this,
            i;

        for (i in that.options.publication.base_maps) {
            if (that.options.publication.base_maps[i].id == id) {
                return that.options.publication.base_maps[i];
            }
        }
        return false;
    },

    /**
     *
     */
    switchBaseLayer: function(baseId){
        var that = this,
            baseMaps = that.options.publication['base_maps'],
            baseMap;

        // *************************************************************
        // Встречаем новую логику переключения подл...?, нет, чего то...
        // *************************************************************

        baseMap = that._getBaseInfoById(baseId);
        if (!baseMap) {
            return;
        }

        if (baseMaps && baseMaps.length > 0) {
            // Переключаем слой с подложками но не с тайловыми подложками OMS
            that._baseLayer.switchTo(baseId);

            if (baseMap.type == 'OMS' && !baseMap.vector) {
                // Всетаки не прокатило
                that._showOmsBases(baseMap);
                that._baseLayer.fire('layerChanged', {'layerName': baseMap.id});
            } else {
                that._hideOmsBases();
            }
        }
    },

    /**
     * Метод тушит любую подложку OMS в любом режиме отображения
     * @private
     */
    _hideOmsBases: function(){
        var that = this,
            i,
            mapLayer,
            commonLayer,
            codesForHide = [];

        that._layers.each(function(l){
            if (l.options.baseId != undefined) {
                l.hide();
            }
            if (l.options.commonLayer) {
                commonLayer = l;
            }
        });

        if (commonLayer) {
            for ( i in that._mapLayersInfo) {
                mapLayer = that._mapLayersInfo[i];
                if (mapLayer.baseId) {
                    codesForHide = codesForHide.concat(mapLayer.activeLayers);
                }
            }
            if (codesForHide.length > 0) {
                commonLayer.deactivateLayers(codesForHide);
                if(!commonLayer.getActiveLayerCodes().length){
                    commonLayer.hide();
                }
            }
        }
    },

    _showOmsBases: function(baseMap){
        var that = this,
            commonLayer,
            mapLayer,
            i;

        that._hideOmsBases();

        that._layers.each(function(l){
            if (l.options.baseId == baseMap['container_id']) {
                l.show();
            }
            if (l.options.commonLayer) {
                commonLayer = l;
            }
        });

        if (commonLayer) {
            for ( i in that._mapLayersInfo) {
                mapLayer = that._mapLayersInfo[i];
                if (mapLayer.baseId) {
                    if (mapLayer.baseId == baseMap['container_id']) {
                        commonLayer.activateLayers(mapLayer.activeLayers);
                        if(!commonLayer.isVisible()){
                            commonLayer.show();
                        }
                    }
                }
            }
        }
    },

    _prepareOmsBases: function(containers){
        var that = this,
            omsBases = {},
            container,
            childs,
            baseMapContsMap = {},
            vectorChilds;
            /*first = false;*/

        that.options.publication.base_maps.forEach(function(bm, i) {
            // Если это базовая карта OMS то нужно подготовить ее объект
            if (bm.type == 'OMS') {
                container        = containers.filter(function (c) {
                    return c.get('map_layer_id') == bm['container_id'];
                }).at(0);
                if(container && bm['container_id']) {
                    container.baseId = bm['container_id'];

                    childs = that._getContDescendants(bm['container_id'], containers.getArray());

                    vectorChilds = childs.filter(function (ch) {
                        return ch.get('render_type') == 1;
                    });
                    vectorChilds.forEach(function (vc) {
                        vc.baseId = bm['container_id'];
                        vc.options.baseId = bm['container_id'];
                    });

                    omsBases[bm['container_id']] = {
                        index: i,
                        vectorContainers: vectorChilds,
                        selected: bm['selected'],
                        isVector: bm['vector']
                    };

                    // Добавляем ссылку на объект базовой карты всем контейнерам, которые участвуют в базовых картах.
                    // Нельзя использовать baseId т.к. этот атрибут уже используется с завязкой на то, что он может быть только у векторных слоёв.
                    // TODO: Не верно определять режим отображения слоя по наличию атрибута baseId. От этой завязки нужно избавляться.

                    container.baseMapRef = omsBases[bm['container_id']];
                    container.baseMapRefId = bm['container_id'];
                    container.options.baseMapRef = omsBases[bm['container_id']];
                    container.options.baseMapRefId = bm['container_id'];
                    childs.forEach(function (c) {
                        c.baseMapRef = omsBases[bm['container_id']];
                        c.baseMapRefId = bm['container_id'];
                        c.options.baseMapRef = omsBases[bm['container_id']];
                        c.options.baseMapRefId = bm['container_id'];
                    });

                    baseMapContsMap[bm.id] = childs.slice();
                    baseMapContsMap[bm.id].unshift(container);
                    baseMapContsMap[bm.id] = baseMapContsMap[bm.id]
                        .filter(function (c) {
                            return c.get('selected') && c.get('render_type') == 0 && !~['folder', 'raster'].indexOf(c.get('type'));
                        })
                        .map(function (c) {
                            return c.get('map_layer_id');
                        });
                }
            }
        });

        that.getBaseLayer()._setBaseMapContainers(baseMapContsMap);

        return omsBases;
    },


    _findVectorLayers: function (containers, parent_id) {
        var that = this,
            vLayers = [],
            descLayers;

        descLayers = parent_id
            ? containers.filter(function (layer) {
                return layer.get('parent_id') == parent_id;
            })
            : containers;


        descLayers.each(function (layer) {
            if (layer.get('type') == 'folder') {
                var vvlayers = that._findVectorLayers(containers, layer.get('map_layer_id'));
                vLayers = vLayers.concat(vvlayers);
            } else {
                if (layer.get('render_type') == 1) vLayers.push(layer);
            }
        });
        return vLayers;
    },

    //формируем loader для векторного слоя
    _createVectorLayerLoader: function (vl, publish_containers, beforeVectorAdd, omsBases) {
        var that = this,
            baseLayerInfo,
            layerType,
            visibility;
        // Выясняем тип векторного слоя
        layerType = C.OMS_VECTOR_LAYER;
        if (vl.get('style_mode') == 3) {
            if (vl.get('visualSettings').type == 2) {
                layerType = C.OMS_CATEGORY_LAYER;
            } else if (~[4, 5, 6].indexOf(vl.get('visualSettings').type)) {
                layerType = C.OMS_CHARTS_LAYER;
            }
        }

        baseLayerInfo = ('baseId' in vl && vl.baseId != undefined)
            ? omsBases[vl.baseId]
            : false;

        visibility = (baseLayerInfo)
            ? baseLayerInfo.selected
            : vl.get('selected');

        var isBaseLayer = baseLayerInfo && baseLayerInfo.selected;
        var isSelected = vl.get('selected');
        var inPublishLayers = ~publish_containers.pluck('code').indexOf(vl.get('code'));
        var layerPubConfig = that.options.publication.layers_config.filter(function (conf) {
            return conf.containerId == vl.get('id');
        })[0];
        var fieldsToLoad = [];
        if (layerPubConfig) {
            if (layerPubConfig.objectNameAutoChoose) {
                fieldsToLoad.push('name');
                fieldsToLoad.push('label');
            } else {
                fieldsToLoad.push(layerPubConfig.objectNameColumnCode);
            }
        }

        var loadingOptions;
        if (isBaseLayer || isSelected || inPublishLayers) {
            loadingOptions = {
                layerType: layerType,
                visible: visibility,
                baseId: vl.baseId,
                f: 'fjson',
                fields: fieldsToLoad
            };
            if (beforeVectorAdd && typeof beforeVectorAdd === 'function') {
                loadingOptions = beforeVectorAdd.call(null, vl, loadingOptions)
            }
            return that.addLayer(vl.get('code'), loadingOptions);
        }
        return null;
    },

    //формируем mapInfo для растрового слоя
    _createTileLayerInfo: function (tl, omsBases) {
        var that = this,
            activeChilds,
            mapLayerInfo,
            contId = tl.get('map_layer_id');

        if (tl.get('map_layer_id') in omsBases) {
            activeChilds = [tl.get('code')];
        } else {
            activeChilds = tl.get('selected') ? [tl.get('code')] : [];
        }
        mapLayerInfo = {
            codes: [tl.get('code')],
            activeLayers: activeChilds,
            baseId: contId in omsBases ? contId : undefined,
            selected: contId in omsBases && omsBases[contId].selected
        };
        return mapLayerInfo;
    },

    //формируем mapInfo для папки
    _createFolderTileInfo: function (containers, options) {
        var that = this,
            mapLayerInfo,
            contId,
            childs,
            activeChilds;

        contId = options.contId;
        childs = that._getContDescendants(contId, containers.getArray());

        // на случай вызова из однослойного  режима
        childs = childs.filter(function (ch) {
            return ch.get('render_type') != 1;
        });

        activeChilds = childs
            .filter(function (ch) {
                return ch.get('selected');
            })
            .map(function (ch) {
                return ch.get('code');
            });
        childs = childs.map(function (ch) {
            return ch.get('code');
        });
        if (childs.length) {
            mapLayerInfo = {
                codes: childs,
                activeLayers: activeChilds,
                baseId: contId in options.omsBases ? contId : undefined,
                selected: contId in options.omsBases && options.omsBases[contId].selected,
                layerType: options.view_format_type,
                tilesQuality: options.tiles_quality
            };
        }
        return mapLayerInfo;
    },

    //формируем mapInfo для коллекции
    _createCollectionInfo: function (descLayers, containers, options) {
        var that = this,
            mapLayersInfo = [],
            contId,
            lcodes = [],
            acodes = [],
            folderMapInfo,
            mapLayer;

        descLayers.each(function (tl) {
            contId = tl.get('map_layer_id');
            if (tl.get('type') == 'folder') {
                folderMapInfo = that._createFolderTileInfo(containers, {
                    omsBases: options.omsBases,
                    contId: tl.get('map_layer_id'),
                    view_format_type: options.view_format_types[tl.get('view_format_type')],
                    tiles_quality: tl.get('tiles_quality')
                });
                if (folderMapInfo) mapLayersInfo.push(folderMapInfo);
            } else {
                mapLayersInfo.push(that._createTileLayerInfo(tl, options.omsBases));
            }
        });

        for (var i in mapLayersInfo) {
            mapLayer = mapLayersInfo[i];
            if (mapLayer.baseId != undefined) {
                lcodes = lcodes.concat(mapLayer.codes);
                if (mapLayer.selected) {
                    acodes = acodes.concat(mapLayer.activeLayers);
                }
            } else {
                lcodes = lcodes.concat(mapLayer.codes);
                acodes = acodes.concat(mapLayer.activeLayers);
            }
        }
        return {
            codes: {
                lcodes: lcodes,
                acodes: acodes
            },
            mapLayersInfo: mapLayersInfo
        }
    },

    //формируем лоадеры для слоев по порядку
    _createLoadersAuto: function (options, containers, parent_id) {
        var that = this,
            loaders = [],
            mapLayersInfo = [],
            mapLayer,
            data,
            descLayers,
            vLoader,
            formats = [],
            value,
            equal = true,
            default_params = [0, 1];

        descLayers = containers.filter(function (layer) {
            return (parent_id > 0)
                ? layer.get('parent_id') == parent_id
                : layer.get('parent_id') == 0;
        });

        var vLayers = that._findVectorLayers(containers, parent_id);

        // в корне при отсутствии векторных слоев проверяем форматы растровых слоев
        if (parent_id === 0 && vLayers.length == 0) {
            descLayers.each(function (l) {
                if (l.get('type') == 'folder') {
                    value = l.get('view_format_type') + '';
                    if (l.get('view_format_type') == 0) {
                        value += '.' + l.get('tiles_quality');
                    }
                    formats.push(value);
                } else {
                    formats.push('0.1')
                }
                default_params = [
                    l.get('view_format_type') || 0,
                    l.get('tiles_quality') || 1
                ]
            });
            equal = formats.every(function (value, i, arr) {
                return value == arr[0];
            });
        }

        // если слои в одном формате все приводим к одному слою
        if (vLayers.length == 0 && equal) {

            if (parent_id > 0) {// если мы во вложенной папке
                var fLayer = containers._items.filter(function (l) {
                    return l.get('map_layer_id') == parent_id;
                })[0];
                mapLayer = that._createFolderTileInfo(containers, {
                    omsBases: options.omsBases,
                    contId: fLayer.get('map_layer_id'),
                    view_format_type: options.view_format_types[options.view_format_type],
                    tiles_quality: options.tiles_quality
                });
                if (mapLayer) {
                    mapLayersInfo.push(mapLayer);
                    loaders.push(that.addLayer(mapLayer.codes.join(' '), {
                        visible: mapLayer.baseId != undefined ? mapLayer.selected : mapLayer.activeLayers.length > 0,
                        activeLayers: mapLayer.activeLayers,
                        projectLayerCodes: mapLayer.codes,
                        baseId: mapLayer.baseId,
                        layerType: mapLayer.layerType,
                        tilesQuality: mapLayer.tilesQuality
                    }));
                }
            } else {// и если мы в корне

                data = that._createCollectionInfo(descLayers, containers, {
                    omsBases: options.omsBases,
                    view_format_types: options.view_format_types
                });
                loaders.push(that.addLayer(data.codes.lcodes.join(' '), {
                    activeLayers: data.codes.acodes,
                    commonLayer: true,
                    layerType: options.view_format_types[default_params[0]],
                    tilesQuality: default_params[1]
                }));
                mapLayersInfo = data.mapLayersInfo;
            }

            return {
                loaders: loaders,
                mapLayersInfo: mapLayersInfo
            }
        }

        // если слои в разном формате раскладываем на слои
        descLayers.each(function (layer) {
            if (layer.get('type') == 'folder') { //папка
                if (parent_id > 0) {
                    options = $.extend(options, {
                        view_format_type: options.view_format_type,
                        tiles_quality: options.tiles_quality
                    });
                } else {
                    options = $.extend(options, {
                        view_format_type: layer.get('view_format_type'),
                        tiles_quality: layer.get('tiles_quality')
                    });
                }
                data = that._createLoadersAuto(options, containers, layer.get('map_layer_id'));
                loaders = loaders.concat(data.loaders);
                mapLayersInfo = mapLayersInfo.concat(data.mapLayersInfo);

            } else // слой
            {
                if (layer.get('render_type') == 1) {//  векторный
                    vLoader = that._createVectorLayerLoader(layer, options.publish_containers, options.beforeVectorAdd, options.omsBases);
                    if (vLoader) loaders.push(vLoader);
                } else { // растровый
                    mapLayer = that._createTileLayerInfo(layer, options.omsBases);
                    loaders.push(that.addLayer(mapLayer.codes.join(' '), {
                        visible: mapLayer.baseId != undefined ? mapLayer.selected : mapLayer.activeLayers.length > 0,
                        activeLayers: mapLayer.activeLayers,
                        projectLayerCodes: mapLayer.codes,
                        baseId: mapLayer.baseId,
                        layerType: mapLayer.layerType,
                        tilesQuality: mapLayer.tilesQuality
                    }));
                    mapLayersInfo.push(mapLayer);
                }
            }
        });

        return {
            loaders: loaders,
            mapLayersInfo: mapLayersInfo
        };
    },

    //Новая функция формирования слоев
    showOMSPublication: function (beforeVectorAdd) {
        var that = this,
            omsBases,
            mapLayersInfo = [],
            view_format_types = [
                C.TILE_LAYER,
                C.OMS_VECTOR_FEATURE_LAYER,
                C.OMS_MVT_LAYER
            ];

        // Нужно проставить центр и зум из настроек публикации
        var publication = that.options.publication,
            mapPosition = publication.map_position;
        // Пользовательское начальное смещение карты
        if (publication.map_position_manual) {
            mapPosition = $.extend(true, {}, mapPosition, publication.map_position_manual);
        }

        that._map.getView().setZoom(mapPosition.zoom);
        that._map.getView().setCenter(mapPosition.center);

        that._setPadding(mapPosition);

        // Прогружаем все контейнеры
        return that.getProject().loadMap()
            .then(function (mapContainer) {
                that._mapContainer = mapContainer;
                return $.when(that.getProject().getContainers(), that.getProject().getContainers({type: 'publish'}));
            })
            .then(function (full_containers, publish_containers) {
                // Приготовим
                var master = $.Deferred(),
                    loaders = [],
                    containers;

                omsBases = that._prepareOmsBases(full_containers);

                // Поскольку векторные базовые карты отображаются без помощи OL, в этой функции они нам не нужны.
                // Выбираем контейнеры, которые не участвуют в векторных базовых картах.
                containers = full_containers.filter(function (c) {
                    // Контейнер участвует в базовых картах
                    // Или участвует в не векторной базовой карте
                    return !('baseMapRef' in c) || !c.baseMapRef.isVector;
                });

                var data;
                var options = {
                    omsBases: omsBases,
                    publish_containers: publish_containers,
                    beforeVectorAdd: beforeVectorAdd,
                    view_format_types: view_format_types
                };

                containers._items.reverse();

                data = that._createLoadersAuto(options, containers, 0);
                loaders = data.loaders;
                mapLayersInfo = data.mapLayersInfo;
                that._mapLayersInfo = mapLayersInfo;


                // TODO: Пахнет жестким костылем
                if (that._baseLayer.cdr_layer != undefined) {
                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_layer);
                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_highlight_layer);
                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_zouit_highlight_layer);
                }


                $.when.apply($, loaders).then(function () {
                    master.resolve(true);
                });

                return master;
            });
    },

    //Старая функция формирования слоев
    __showOMSPublication: function(beforeVectorAdd){
        var that = this,
            omsBases,
            layers,
            mapLayersInfo = [],
            childs,
            activeChilds,
            mapLayer,
            i,
            vectorLayers,
            layerType,
            visibility,
            contId;
        //that.__showOMSPublication(beforeVectorAdd);
        // Нужно проставить центр и зум из настроек публикации
        var publication = that.options.publication,
            mapPosition = publication.map_position;
        // Пользовательское начальное смещение карты
        if (publication.map_position_manual){
            mapPosition = $.extend(true, {}, mapPosition, publication.map_position_manual);
        }

        that._map.getView().setZoom(mapPosition.zoom);
        that._map.getView().setCenter(mapPosition.center);

        that._setPadding(mapPosition);

        // Прогружаем все контейнеры
        return that.getProject().loadMap()
            .then(function(mapContainer){
                that._mapContainer = mapContainer;
                return $.when(that.getProject().getContainers(), that.getProject().getContainers({type:'publish'}));
            })
            .then(function(full_containers, publish_containers){
                // Приготовим
                var master = $.Deferred(),
                    baseLayerInfo,
                    loaders = [],
                    containers;

                omsBases = that._prepareOmsBases(full_containers);

                // Поскольку векторные базовые карты отображаются без помощи OL, в этой функции они нам не нужны.
                // Выбираем контейнеры, которые не участвуют в векторных базовых картах.
                containers = full_containers.filter(function(c){
                    // Контейнер участвует в базовых картах
                    // Или участвует в не векторной базовой карте
                    return !('baseMapRef' in c) || !c.baseMapRef.isVector;
                });

                // Все контейнеры в корне, которые рендерятся тайлами.
                // Для послойного отображения
                layers = containers.filter(function(c) {
                    return c.get('parent_id') == 0 && c.get('render_type') !== 1;
                });
                layers._items.reverse();

                // Боримся с тайловыми слоями
                layers.each(function(tl) {
                    contId = tl.get('map_layer_id');

                    if (tl.get('type') == 'folder') {
                        childs = that._getContDescendants(tl.get('map_layer_id'), containers.getArray());

                        childs = childs.filter(function(ch){
                            return ch.get('render_type') != 1;
                        });

                        activeChilds = childs
                            .filter(function(ch){
                                return ch.get('selected');
                            })
                            .map(function(ch){
                                return ch.get('code');
                            });

                        childs = childs.map(function(ch){
                            return ch.get('code');
                        });

                        if (childs.length) {
                            mapLayersInfo.push({
                                codes: childs,
                                activeLayers: activeChilds,
                                baseId: contId in omsBases ? contId : undefined,
                                selected: contId in omsBases && omsBases[contId].selected,
                                layerType: tl.get('view_format_type') == 1
                                    ? C.OMS_VECTOR_FEATURE_LAYER
                                    : (
                                        tl.get('view_format_type') == 2
                                            ? C.OMS_MVT_LAYER
                                            : C.TILE_LAYER
                                ),
                                tilesQuality: tl.get('tiles_quality')
                            });
                        }
                    } else {
                        if (tl.get('map_layer_id') in omsBases) {
                            activeChilds = [tl.get('code')];
                        } else {
                            activeChilds = tl.get('selected') ? [tl.get('code')] : [];
                        }
                        mapLayersInfo.push({
                            codes: [tl.get('code')],
                            activeLayers: activeChilds,
                            baseId: contId in omsBases ? contId : undefined,
                            selected: contId in omsBases && omsBases[contId].selected
                        });
                    }
                });

                /** Создаем слои карты */
                // Послойное отображение
                if (that._mapContainer.get('group_layers') == 0) {
                    for (i in mapLayersInfo) {
                        mapLayer = mapLayersInfo[i];
                        loaders.push(that.addLayer(mapLayer.codes.join(' '), {
                            visible: mapLayer.baseId != undefined ? mapLayer.selected : mapLayer.activeLayers.length > 0,
                            activeLayers: mapLayer.activeLayers,
                            projectLayerCodes: mapLayer.codes,
                            baseId: mapLayer.baseId,
                            layerType: mapLayer.layerType,
                            tilesQuality: mapLayer.tilesQuality
                        }));
                    }
                } else { // Отображение единым слоем
                    var lcodes = [];
                    var acodes = [];
                    for (i in mapLayersInfo) {
                        mapLayer = mapLayersInfo[i];
                        if (mapLayer.baseId != undefined) {
                            lcodes = lcodes.concat(mapLayer.codes);
                            if (mapLayer.selected) {
                                acodes = acodes.concat(mapLayer.activeLayers);
                            }
                        } else {
                            lcodes = lcodes.concat(mapLayer.codes);
                            acodes = acodes.concat(mapLayer.activeLayers);
                        }
                    }
                    loaders.push(that.addLayer(lcodes.join(' '), {
                        activeLayers: acodes,
                        commonLayer: true
                    }));
                }
                that._mapLayersInfo = mapLayersInfo;

                // TODO: Пахнет жестким костылем
                if (that._baseLayer.cdr_layer != undefined) {
                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_layer);
                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_highlight_layer);
                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_zouit_highlight_layer);
                }

                // Нужно отобразить векторные слои в обратном порядке
                vectorLayers = containers.filter(function(c){
                    return c.get('render_type') == 1;
                });

                vectorLayers._items.reverse();
                vectorLayers.each(function(vl){
                    // Выясняем тип векторного слоя
                    layerType = C.OMS_VECTOR_LAYER;
                    if (vl.get('style_mode') == 3) {
                        if (vl.get('visualSettings').type == 2){
                            layerType = C.OMS_CATEGORY_LAYER;
                        } else if (~[4,5,6].indexOf(vl.get('visualSettings').type)) {
                            layerType = C.OMS_CHARTS_LAYER;
                        }
                    }

                    baseLayerInfo = ('baseId' in vl && vl.baseId != undefined)
                        ? omsBases[vl.baseId]
                        : false;

                    visibility = (baseLayerInfo)
                        ? baseLayerInfo.selected
                        : vl.get('selected');

                    var isBaseLayer = baseLayerInfo && baseLayerInfo.selected;
                    var isSelected = vl.get('selected');
                    var inPublishLayers = ~publish_containers.pluck('code').indexOf(vl.get('code'));
                    var layerPubConfig = that.options.publication.layers_config.filter(function(conf){
                        return conf.containerId == vl.get('id');
                    })[0];
                    var fieldsToLoad = [];
                    if(layerPubConfig){
                        if(layerPubConfig.objectNameAutoChoose){
                            fieldsToLoad.push('name');
                            fieldsToLoad.push('label');
                        }else{
                            fieldsToLoad.push(layerPubConfig.objectNameColumnCode);
                        }
                    }

                    var loadingOptions;
                    if (isBaseLayer || isSelected || inPublishLayers) {
                        loadingOptions = {
                            layerType: layerType,
                            visible: visibility,
                            baseId: vl.baseId,
                            f: 'fjson',
                            fields: fieldsToLoad
                        };
                        if (beforeVectorAdd && typeof beforeVectorAdd === 'function') {
                            loadingOptions = beforeVectorAdd.call(null, vl, loadingOptions)
                        }
                        loaders.push(that.addLayer(vl.get('code'), loadingOptions));
                    }
                    //var vLoader = that.createVectorLayerLoader(vl, publish_containers, beforeVectorAdd);
                    //if (vLoader) loaders.push(vLoader);

                });
                $.when.apply($, loaders).then(function(){
                    master.resolve(true);
                });

                return master;
            });
    },

    getActiveProjectLayers: function(){
        var that = this,
            ids,
            activeLayers = [];

        that._layers.getArray().forEach(function(layer){
            if (!(layer instanceof Layer) || !layer._prjLayers || !layer._prjLayers.getLength()){
                return;
            }

            if (layer.isVisible()) {
                if (layer instanceof TileLayer) {
                    ids = layer.getSource().getActiveLayers();
                    if (ids.length) {
                        activeLayers = activeLayers.concat(layer._prjLayers.getArray().filter(function(player){
                            return ~ids.indexOf(player.get('map_layer_id')) != 0;
                        }));
                    }
                } else {
                    activeLayers = activeLayers.concat(layer._prjLayers.getArray());
                }
            }
        });

        return activeLayers;
    },

    _getContDescendants: function (parent_id, conts) {
        var that        = this;
        var descendands = [];
        for (var i in conts) {
            if (conts[i].get('parent_id') == parent_id) {
                if (conts[i].get('type') == 'folder') {
                    descendands = descendands.concat(that._getContDescendants(conts[i].get('map_layer_id'), conts));
                } else {
                    descendands.push(conts[i]);
                }
            }
        }

        return descendands;
    },

    /**
     *
     */
    getMeasurement: function(){
        return this._measurement;
    },

    /**
     *
     */
    getPublicMapDraw: function() {
        return this._publicMapDraw;
    },

    getGeometryEditor: function() {
        return this._genericGeometryEditor;
    },

    /**
     *
     */
    addMarker: function(coordinates, options){
        var that = this,
            _layers,
            markerLayer;

        options || (options = {});
        if (options.group == undefined) {
            options.group = 'default';
        }

        _layers = that._markerLayers.filter(function(layer){
            return layer.get('group') == options.group;
        });

        if (_layers.getLength() == 0) {
            markerLayer = new MarkerLayer({
                'group': options.group
            });
            that._markerLayers.add(markerLayer);
        } else {
            markerLayer = _layers.at(0);
        }

        return markerLayer.addMarker.call(markerLayer, coordinates, options);
    },

    /**
     *
     */
    getMarkerGroup: function(name){
        var that = this;

        if (name === undefined) {
            name = 'default';
        }
        return that._markerLayers.filter(function(l){
            return l.get('group') == name;
        }).at(0);
    },

    _parseLocationQuery: function(){
        var searchParamsArray, keyvalarr;
        var searchParamsObject = {};
        var searchQuery = window.location.search;
        searchQuery = searchQuery.substr(1, searchQuery.length-1);
        searchParamsArray = searchQuery.split("&");
        for (var i = 0; i < searchParamsArray.length; i++) {
            if (/\w*=\w*/.test(searchParamsArray[i])) {
                keyvalarr = searchParamsArray[i].split("=");
                searchParamsObject[keyvalarr[0]] = keyvalarr[1];
            }
        }
        return searchParamsObject;
    },

    syncWithProject: function(without) {
        var that = this;

        that._layers.each(function(layer) {
            if (typeof layer.syncWithProject === 'function') {
                layer.syncWithProject(without);
            }
        });
    }
});

module.exports = View;



//////////////////
// WEBPACK FOOTER
// ./src/View/View.js
// module id = 20
// module chunks = 0